import { useState, useEffect } from 'react';
import { ChargerAttributes } from '../models/charger-model';
import { getLastUsedCharger } from '../services/charger-service';
import { isSuccessful } from '../services/api-requests';

export const useLastUsedCharger = () => {
  const [lastUsedCharger, setLastUsedCharger] =
    useState<ChargerAttributes | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchLastUsedCharger = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await getLastUsedCharger();

      // Handle null response
      if (!response) {
        setLastUsedCharger(null);
        return;
      }

      // Handle successful response
      if (
        response.status &&
        isSuccessful(response.status) &&
        response.payload
      ) {
        setLastUsedCharger(response.payload);
      } else {
        setLastUsedCharger(null);
      }
    } catch (err) {
      console.error('Error fetching last used charger:', err);
      setError('Failed to fetch last used charger');
      setLastUsedCharger(null);
    } finally {
      setIsLoading(false);
    }
  };

  const clearLastUsedCharger = () => {
    setLastUsedCharger(null);
    setError(null);
  };

  useEffect(() => {
    // Only fetch on mount if needed
    // This can be called manually when user logs in
  }, []);

  return {
    lastUsedCharger,
    isLoading,
    error,
    fetchLastUsedCharger,
    clearLastUsedCharger,
  };
};
